// removed by extract-text-webpack-plugin
module.exports = {"intro":"_3MGF2qYDdOR1wGvde4VwN9","title":"_3OrQtcUJfg0EWez7EiOTTs","introSection":"_3MPfKhctchSCcP2IM6Vlo_","header":"oHCGeCyRun4hfiyNw4fPP","introTable":"_2PCPIdpcmhTgmhsfhecHbE","sectionTitle":"fKUWOmoCpHOm1SJGarRlG","introLeft":"_15ktmUB4iBT4F-LhNKbull","introRightLogo":"_2JeOvmp7wC1HwhxMl8F7G_","headerTable":"_3zbfdeB9EdkGldcmGwEoc_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Policy/Intro.scss
// module id = 161
// module chunks = 0